module.exports = __webpack_public_path__ + "img/a6ac3ee.svg";